/**
 * DOM elements that make up the whiteboard's own rendering surface, registered on
 * `window.posterEditor.elements`. Domain code (poster-whiteboard) reads these to measure
 * and position the canvas, so the enum lives in the domain layer where the fence permits a
 * value import. Editor-shell chrome (navbar, bottom bars) lives in `PosterEditorShellElement`
 * in the UI layer instead.
 */
export enum WhiteboardDomElement {
  WHITEBOARD_CONTAINER = 'WHITEBOARD_CONTAINER',
  WHITEBOARD = 'WHITEBOARD',
  POST_POSTER_ELEMENT = 'POST_POSTER_ELEMENT',
}
